export default {"src":"/_next/static/media/0x2791bca1f2de4661ed88a30c99a7a9449aa84174.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};